<template>
  <div
    @click="handleClick"
    :class="[
      'p-2 rounded-xl mt-2 whitespace-pre-wrap break-words font-inherit',
      isUser ? 'bg-paletteDarkGreen text-white self-end' : 'bg-gray-200 self-start',
      matchSelectedMessageId(props.messageId) ? (isUser ? 'outline outline-2 outline-paletteDarkGreen outline-offset-2' : 'outline outline-2 outline-gray-200 outline-offset-2') : '',
      explanationStore.loading || isAlreadySelected ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
    ]"
  >
    {{ message }}
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import { useExplanationStore } from '@/stores/explanations'
import { useMessagesStore } from '@/stores/messages'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  message: String,
  isUser: Boolean,
  messageId: Number
})
const explanationStore = useExplanationStore()
const messageStore = useMessagesStore()
const { locale } = useI18n()

const emit = defineEmits(['select'])
// Check if the message is already selected
const isAlreadySelected = computed(() => props.messageId === explanationStore.selectedMessageId)

function handleClick () {
  if (explanationStore.loading || isAlreadySelected.value) return
  selectMessage(props.messageId, props.message, props.isUser)
}

function matchSelectedMessageId (messageId) {
  return messageId === explanationStore.selectedMessageId
}

async function selectMessage (messageId, messageText, isUser) {
  try {
    explanationStore.setSelectedMessage(messageText, messageId, isUser)
    await explanationStore.getMessageInsight(messageStore.currentConversation.conversation_id, messageId, locale.value)
    emit('open-insights') // Open sidebar
  } catch (error) {
    console.error('Error fetching insights:', error)
  }
}
</script>
